import { render } from "./DemandChart.vue?vue&type=template&id=981c1c6a"
import script from "./DemandChart.vue?vue&type=script&lang=ts"
export * from "./DemandChart.vue?vue&type=script&lang=ts"
script.render = render

export default script